import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import { FiEye } from "react-icons/fi";
import React from "react";
import Tooltip from "components/tooltip/Tooltip";

// Ticket status → badge
export const OFFLINE_STATUS = {
  open: { label: "Open", cls: "bg-blue-100 text-blue-700" },
  assigned: { label: "Assigned", cls: "bg-yellow-100 text-yellow-700" },
  resolved: { label: "Resolved", cls: "bg-green-100 text-green-700" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700" },
};

const OfflineTable = ({ roledata, onOpen }) => (
  <TableBody>
    {roledata?.map((data, index) => {
      const status = OFFLINE_STATUS[data.status] || OFFLINE_STATUS.open;
      return (
        <TableRow key={data.id} className="cursor-pointer hover:bg-gray-50" onClick={() => onOpen(data)}>
          <TableCell className="text-center text-xs">{index + 1}</TableCell>
          <TableCell className="text-center text-xs">{data.ref_no || data.id}</TableCell>
          <TableCell className="text-center text-xs">{data.company_name || "-"}</TableCell>
          <TableCell className="text-center text-xs">{data.subject || "-"}</TableCell>
          <TableCell className="text-center text-xs">{data.created_at || "-"}</TableCell>
          <TableCell className="text-center text-xs">
            <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${status.cls}`}>{status.label}</span>
          </TableCell>
          <TableCell className="text-center text-xs">{data.assigned_name || "-"}</TableCell>
          <TableCell>
            <div className="p-2 text-center">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onOpen(data);
                }}
                className="p-2 text-gray-400 hover:text-green-600 focus:outline-none"
              >
                <Tooltip id={data.id} Icon={FiEye} title="Open" bgColor="#34D399" />
              </button>
            </div>
          </TableCell>
        </TableRow>
      );
    })}
  </TableBody>
);

export default OfflineTable;
